import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { updateTimeRange } from 'custom_hooks/data_hooks/time_ranges/useTimeRange';
import { TimeRangeTableCellProps } from 'pages/Settings/TimeRanges/TimeRanges';

const errorMessage = 'Unable to save time range name.';

export function TimeRangeNameCell({ rowData, onChange }: TimeRangeTableCellProps) {
    const onSave = async (newValue: string | undefined) => {
        if (!newValue) {
            return errorMessage;
        }
        try {
            await updateTimeRange(rowData, { Name: newValue });
            onChange();
        } catch {
            return errorMessage;
        }
        return undefined;
    };
    return (
        <TextInlineEditor
            ariaLabel={`${rowData.Name} time range name cell`}
            onConfirm={onSave}
            value={rowData.Name}
            validate={(v) => {
                if (!v || !v.trim()) {
                    return 'Time Range name is required';
                }
                if (v.length > 5) {
                    return 'Time Range name must be 5 characters or less';
                }
                return undefined;
            }}
        />
    );
}
